import callApi from "helpers/callApi";

export const FUND_REQUEST_CREATE_ENDPOINT = "/manager/billing_history/fund_request";

export function getFundRequestByIdEndpoint(fundRequestId) {
  return `/manager/billing_history/fund_request/${fundRequestId}`;
}

export const getFundRequestUpdateEndpoint = getFundRequestByIdEndpoint;
export const getFundRequestDeleteEndpoint = getFundRequestByIdEndpoint;

async function parseFundRequestApiError(response, fallbackMessage) {
  let message = `HTTP ${response.status}`;
  try {
    const errBody = await response.json();
    message = errBody?.message || errBody?.error || message;
  } catch (_) {
    try {
      message = await response.text();
    } catch (_) {}
  }
  throw new Error(message || fallbackMessage);
}

export async function createFundRequest(payload) {
  const response = await callApi(FUND_REQUEST_CREATE_ENDPOINT, "POST", payload);
  if (!response.ok) {
    await parseFundRequestApiError(response, "Failed to create fund request");
  }
  return response.json();
}

export async function updateFundRequest(fundRequestId, payload) {
  const response = await callApi(getFundRequestUpdateEndpoint(fundRequestId), "PATCH", payload);
  if (!response.ok) {
    await parseFundRequestApiError(response, "Failed to update fund request");
  }
  return response.json();
}

export async function deleteFundRequest(fundRequestId) {
  const response = await callApi(getFundRequestDeleteEndpoint(fundRequestId), "DELETE");
  if (!response.ok) {
    await parseFundRequestApiError(response, "Failed to delete fund request");
  }
  if (response.status === 204) {
    return null;
  }
  try {
    return await response.json();
  } catch (_) {
    return null;
  }
}
